import { render, staticRenderFns } from "./TermofUseSection.vue?vue&type=template&id=4f9b44af&scoped=true"
import script from "./TermofUseSection.vue?vue&type=script&lang=js"
export * from "./TermofUseSection.vue?vue&type=script&lang=js"
import style0 from "./TermofUseSection.vue?vue&type=style&index=0&id=4f9b44af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b44af",
  null
  
)

export default component.exports